import { useVersionCheck } from '@/hooks/useVersionCheck';

interface SilentUpdaterProps {
  enabled?: boolean;
  gracePeriodMs?: number;
}

/**
 * Componente headless: no renderiza nada. Aplica las actualizaciones de
 * versión de forma silenciosa (recarga en segundo plano) cuando `enabled` es
 * true. Se usa a través de `RouteAwareUpdateBanner` para respetar las rutas.
 */
export function SilentUpdater({ enabled = true, gracePeriodMs }: SilentUpdaterProps) {
  useVersionCheck({ enabled, gracePeriodMs });
  return null;
}
